import Config from "Config";
import axiosCalls from "global/util/axiosCalls";
import AutomatStatusDTO from "./dto/AutomatStatusDTO";
import AutomatStatusLogDTO from "./dto/AutomatStatusLogDTO";
import AutomatStatus from "./interface/AutomatStatus";
import AxiosResponseToAutomatStatusDTOMapper from "./mapper/AxiosResponseToAutomatStatusDTOMapper";

export enum AutomatStatusTyps {
  AT_MM = "AT_MM",
  AT_LOG = "AT_LOG",
  AT_DPGBTB = "AT_DPGBTB",
  AT_EDKBTB = "AT_EDKBTB",
  CD_STD = "CD_STD",
  CD_MMQUIT = "CD_MMQUIT",
}

const AutomatStatusService = {
  retrieveAutomatenStatus: (
    automatkey: string,
    lastDays: number,
    callbackOnSuccess: Function,
    callbackOnFail: Function
  ) => {
    axiosCalls
      .sendGet(
        Config.dataServiceUrl + "automate/status/" + automatkey + "/" + lastDays
      )
      .then((response) => {
        const ResponseDTO: AutomatStatus =
          AxiosResponseToAutomatStatusDTOMapper.map(response);
        callbackOnSuccess(ResponseDTO);
      })
      .catch((error) => {
        callbackOnFail(error);
      });
  },
  retrieveAutomatenStatusLog: (
    automatkey: string,
    day: string,
    type: AutomatStatusTyps,
    callbackOnSuccess: Function
  ) => {
    axiosCalls
      .sendGet(
        Config.dataServiceUrl +
          "automate/status/search/log/" +
          automatkey +
          "/" +
          day +
          "/" +
          type
      )
      .then((response) => {
        callbackOnSuccess(
          AutomatStatusLogDTO.convertResponseToAutomatStatusLogDTO(response)
        );
      })
      .catch((error) => {
        console.log(error);
        // @TODO fire error message
      });
  },
  failedAutomatMM: (
    callbackOnSuccess: Function,
    automatkey?: string | null, // null for all
    callbackOnFail?: Function
  ) => {
    axiosCalls
      .sendGet(Config.dataServiceUrl + "automate/status/failedAutomat", {
        params: {
          automatKey: automatkey,
        },
      })
      .then((response) => {
        callbackOnSuccess(
          AutomatStatusDTO.convertFailedAutomatResponse(response)
        );
      })
      .catch(() => {
        if (callbackOnFail) callbackOnFail();
      });
  },
  getNOKZuOK: (callbackOnSuccess: Function, callbackOnFail?: Function) => {
    axiosCalls
      .sendGet(Config.dataServiceUrl + "automate/status/failedAutomatYesterday")
      .then((response) => {
        callbackOnSuccess(
          AutomatStatusDTO.convertFailedAutomatResponse(response)
        );
      })
      .catch(() => {
        if (callbackOnFail) callbackOnFail();
      });
  },
};

export default AutomatStatusService;
